import {
  Text,
  Primary13SemiBold,
  Primary13Regular,
  Td,
  Tr,
  Box
} from '@sequencehq/core-components'

export const EmptyContent = () => (
  <Tr>
    <Td colSpan={4}>
      <Box width="400px" margin="12px auto" textAlign="center">
        <Text {...Primary13SemiBold} color="gray.90">
          No contacts to display
        </Text>
        <Text {...Primary13Regular} color="gray.80">
          You have not created a contact for this customer yet.
        </Text>
      </Box>
    </Td>
  </Tr>
)
